<template>
  <a-modal :title="record.name + ' - 关联职位'" :width="900" v-model="visible" destroyOnClose>
    <!-- <a-alert message="通过职位ID关联" type="info" /> -->
    <a-row type="flex" align="top" class="item">
      <a-col span="2">职位ID：</a-col>
      <a-col span="22">
        <a-textarea placeholder="请填写关联职位的id,多个职位请用英文逗号隔开" :rows="3" v-model="job_ids" />
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" align="top" :gutter="10">
      <a-col>
        已关联职位
        <span v-show="jobs.length > 0">({{ jobs.length }})</span>：
      </a-col>
      <a-col v-if="jobs.length > 0" style="flex:1">
        <template v-for="job in jobs">
          <a-tag
            closable
            @close="unbind(job)"
            :key="job.id"
            style="margin-bottom:10px;font-size:14px"
          >
            {{
            `${job.job_id}-${job.job_name}`
            }}
          </a-tag>
        </template>
      </a-col>
      <a-col v-else>暂无</a-col>
    </a-row>
    <!-- <a-alert message="通过行业关联" type="info" />
    <a-row type="flex" align="top" class="item">
      <a-col span="2">关联行业：</a-col>
      <a-col span="22">
        <multi-cascade
          ref="industry"
          :selections="industrySelection"
          :options="industryOptions"
        />
      </a-col>
    </a-row>
    <a-alert message="通过职能关联" type="info" />
    <a-row type="flex" align="top" class="item">
      <a-col span="2">关联职能：</a-col>
      <a-col span="22">
        <multi-cascade
          ref="post"
          :selections="postSelection"
          :options="postOptions"
        />
      </a-col>
    </a-row>-->
    <template slot="footer">
      <a-button type="primary" @click="save" :loading="loading">关联</a-button>
    </template>
  </a-modal>
</template>

<script>
import Api from "@/api";
import BaseModal from "@/components/base-modal.vue";
// import MultiCascade from "@/draggable/multi-cascade";
export default {
  name: "joinPostModal",
  extends: BaseModal,
  data() {
    return {
      // postOptions: [],
      // industryOptions: [],
      // industrySelection: [["58"], ["59"], ["60"]],
      // postSelection: [],
      record: {},
      jobs: [],
      job_ids: ""
    };
  },
  // draggable: { MultiCascade },
  async created() {
    // let post = await Api.common.getPostTree();
    // let industry = await Api.common.getIndustryTree();
    // this.industryOptions = industry.tree;
    // this.postOptions = post.tree;
  },
  methods: {
    async save() {
      if (this.job_ids) {
        this.loading = true;
        let { successful, failed } = await Api.im.bindJobs({
          group_id: this.record.id,
          job_ids: this.job_ids
        });
        this.job_ids = "";
        this.loading = false;
        this.$message.info(
          `本次任务成功关联职位：${successful}个，关联失败：${failed}个`
        );
        this.init();
      }
    },
    async init() {
      let { group_jobs } = await Api.im.getBindedJobs({
        group_id: this.record.id
      });
      this.jobs = group_jobs;
    },
    async show(record) {
      this.record = record;
      await this.init();
      this.visible = true;
    },
    async unbind(job) {
      await Api.im.unbindJobs({ group_id: this.record.id, job_id: job.job_id });
      this.jobs = this.jobs.filter(item => item.id != job.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  margin: 30px 0;
}
</style>
